import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const ImpersonationBanner = () => {
  const { impersonation, stopImpersonation } = useAuth();
  const [elapsed, setElapsed] = useState('00:00');
  const [stopping, setStopping] = useState(false);

  useEffect(() => {
    if (!impersonation?.startedAt) return;

    const updateTimer = () => {
      const start = new Date(impersonation.startedAt).getTime();
      const now = Date.now();
      const diff = Math.floor((now - start) / 1000);
      const mins = Math.floor(diff / 60).toString().padStart(2, '0');
      const secs = (diff % 60).toString().padStart(2, '0');
      setElapsed(`${mins}:${secs}`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [impersonation?.startedAt]);

  const handleStop = async () => {
    setStopping(true);
    try {
      await stopImpersonation();
      window.location.href = '/users';
    } catch (err) {
      console.error('Failed to stop impersonation:', err);
      window.location.href = '/';
    } finally {
      setStopping(false);
    }
  };

  if (!impersonation?.active) return null;

  const roleLabelMap = {
    admin: 'Admin',
    head_buyer: 'Head Buyer',
    team_lead: 'Team Lead',
    buyer: 'Buyer',
    custom_manager: 'Custom Manager',
  };

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <span style={styles.text}>
          Impersonation mode: you are logged in as{' '}
          <strong>{impersonation.targetName || 'User'}</strong>
          {impersonation.targetRole && ` (${roleLabelMap[impersonation.targetRole] || impersonation.targetRole})`}
          {' '} — session active {elapsed}
        </span>
        <button onClick={handleStop} style={styles.stopBtn} disabled={stopping}>
          {stopping ? 'Returning...' : 'Return to your account'}
        </button>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 99999,
    background: 'linear-gradient(90deg, #ff9f43, #f7b731)',
    padding: '0 20px',
    boxShadow: '0 2px 12px rgba(255,159,67,0.4)',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '10px 0',
    flexWrap: 'wrap',
  },
  text: {
    color: '#000',
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  stopBtn: {
    padding: '6px 16px',
    background: 'rgba(0,0,0,0.8)',
    border: 'none',
    borderRadius: '6px',
    color: '#ff9f43',
    fontSize: '0.8rem',
    fontWeight: '600',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background 0.2s',
  },
};

export default ImpersonationBanner;
